import { inject, Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { saveAs } from 'file-saver';
import { DateUtils } from '../../../../common/helpers/date-utils';

@Injectable({
  providedIn: 'root',
})
export class CsvService {
  protected readonly dateUtils = inject(DateUtils);
  private apiUrl = environment.apiUrl;
  private http = inject(HttpClient);

  getMonthlyBillingCsv() {
    return this.http.get(this.apiUrl + 'api/csv/monthly-billing', {
      responseType: 'blob',
    });
  }

  getMonthlyBillingCsvByCompanyId(companyId: string, companyName: string) {
    const filename = `monthly-billing-${companyName}.csv`;
    let params = new HttpParams();
    params = params.append('companyId', companyId);

    return this.http.get(this.apiUrl + 'api/csv/monthly-billing', {
      params,
      responseType: 'blob',
    });
  }

  getCompaniesMonthlyBillingCsv() {
    const filename = 'monthly-billing-all-companies.csv';

    return this.http
      .get(this.apiUrl + 'api/csv/monthly-billing-all', {
        responseType: 'blob',
      })
      .subscribe((blob) => {
        saveAs(blob, filename);
      });
  }

  getCompaniesStatsForPeriodCsv(startDate?: Date, endDate?: Date) {
    let params = new HttpParams();

    if (startDate) {
      params = params.append('startDate', startDate.toISOString());
    }

    if (endDate) {
      params = params.append('endDate', endDate.toISOString());
    }

    return this.http.get(this.apiUrl + 'api/csv/companies-stats-for-period', {
      params,
      responseType: 'blob',
    });
  }

  getCompanyStatsForPeriodCsv(
    startDate: Date | undefined,
    endDate: Date | undefined,
  ) {
    let params = new HttpParams();

    if (startDate) {
      params = params.set('startDate', startDate.toISOString());
    }

    if (endDate) {
      params = params.set('endDate', endDate.toISOString());
    }

    return this.http.get(this.apiUrl + 'api/csv/company-stats-for-period', {
      params,
      responseType: 'blob',
    });
  }

  getCompanyStatsByIdForPeriodCsv(
    companyId: string,
    startDate: Date | undefined,
    endDate: Date | undefined,
  ) {
    let params = new HttpParams().set('companyId', companyId);

    if (startDate) {
      params = params.set('startDate', startDate.toISOString());
    }

    if (endDate) {
      params = params.set('endDate', endDate.toISOString());
    }

    return this.http.get(this.apiUrl + 'api/csv/company-stats-for-period', {
      params,
      responseType: 'blob',
    });
  }
}
